// About.js
import React from "react";
import { useTranslation } from "react-i18next";
import "./About.css";
import DotsBanner from "./DotsBanner";  
import Copyright from "./Copyright";
export default function About() {
  const { t } = useTranslation("about");
  return (
    <main className="about">
      {/* Bandeau citation */}
     <section className="about-quote">
  <p>
    {t("quote1")}
    
</p>
<p>
   {t("quote2")}
</p>
</section>


  <DotsBanner
  imageSrc="./Images/pivoine_photo.jpg"
  title={t("dotsBanner.title")}
  text={t("dotsBanner.text")}
  />

   <section className="final-banner">
        <div className="final-banner__inner">
          {/* Image à gauche */}
          <div className="final-banner__media">
            <img
              className="final-banner__img"
              src="./Images/photo_about_us.jpg"   
              alt="Emotions Aero"
              loading="lazy"
            />
          </div>

          {/* Texte à droite */}
          <div className="final-banner__content">
            <h3 className="final-banner__title">{t("finalBanner.title")}</h3>
            <p className="final-banner__text">
             {t("finalBanner.text")}
            </p>
           
          </div>
        </div>
      </section>
      <Copyright/>

    </main>
  );
}
